"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOperator = exports.FILTER_DATE_FORMAT = void 0;
var react_1 = __importStar(require("react"));
var AutocompleteFilterItem_1 = __importDefault(require("./FilterItem/AutocompleteFilterItem"));
var CheckboxFilterItem_1 = __importDefault(require("./FilterItem/CheckboxFilterItem"));
var DateFilterItem_1 = __importDefault(require("./FilterItem/DateFilterItem"));
var DateRangeFilterItem_1 = __importDefault(require("./FilterItem/DateRangeFilterItem"));
var RangeFilterItem_1 = __importDefault(require("./FilterItem/RangeFilterItem"));
var SearchFilterItem_1 = __importDefault(require("./FilterItem/SearchFilterItem"));
var MultipleValueFilterItem_1 = __importDefault(require("./FilterItem/ValuesFilterItem/MultipleValueFilterItem"));
var SingleValueFilterItem_1 = __importDefault(require("./FilterItem/ValuesFilterItem/SingleValueFilterItem"));
exports.FILTER_DATE_FORMAT = "yyyy-MM-dd";
var defaultOperator = function (type) {
    switch (type) {
        case "autocomplete":
            return AutocompleteFilterItem_1.default.defaultOperator;
        case "date":
            return DateFilterItem_1.default.defaultOperator;
        case "date_range":
            return DateRangeFilterItem_1.default.defaultOperator;
        case "checkbox":
            return CheckboxFilterItem_1.default.defaultOperator;
        case "search":
            return SearchFilterItem_1.default.defaultOperator;
        case "range":
            return RangeFilterItem_1.default.defaultOperator;
        case "value":
            return SingleValueFilterItem_1.default.defaultOperator;
        case "values":
        default:
            return MultipleValueFilterItem_1.default.defaultOperator;
    }
};
exports.defaultOperator = defaultOperator;
var FilterItem = /** @class */ (function (_super) {
    __extends(FilterItem, _super);
    function FilterItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterItem.prototype.render = function () {
        var _a = this.props, single = _a.single, type = _a.type;
        switch (type) {
            case "autocomplete":
                return react_1.default.createElement(AutocompleteFilterItem_1.default, __assign({}, this.props));
            case "date":
                return react_1.default.createElement(DateFilterItem_1.default, __assign({}, this.props));
            case "date_range":
                return react_1.default.createElement(DateRangeFilterItem_1.default, __assign({}, this.props));
            case "checkbox":
                return react_1.default.createElement(CheckboxFilterItem_1.default, __assign({}, this.props));
            case "search":
                return react_1.default.createElement(SearchFilterItem_1.default, __assign({}, this.props));
            case "range":
                return react_1.default.createElement(RangeFilterItem_1.default, __assign({}, this.props));
            case "value":
                return react_1.default.createElement(SingleValueFilterItem_1.default, __assign({}, this.props));
            case "values":
                return react_1.default.createElement(MultipleValueFilterItem_1.default, __assign({}, this.props));
            // for backward compatibility
            default:
                if (single) {
                    return react_1.default.createElement(SingleValueFilterItem_1.default, __assign({}, this.props));
                }
                else {
                    return react_1.default.createElement(MultipleValueFilterItem_1.default, __assign({}, this.props));
                }
        }
    };
    return FilterItem;
}(react_1.Component));
exports.default = FilterItem;
//# sourceMappingURL=FilterItem.js.map